import React, { useEffect, useState } from "react";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

const ContactList = () => {
  const [contacts, setContacts] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [perPage] = useState(5);

  useEffect(() => {
    const fetchContacts = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${BASE_URL}/api/contact/getcontactdata`);
        const data = await res.json();
        const contactsArr = Array.isArray(data?.data) ? data.data : [];
        setContacts(contactsArr);
        setFiltered(contactsArr);
      } catch (err) {
        setContacts([]);
        setFiltered([]);
      }
      setLoading(false);
    };
    fetchContacts();
  }, []);

  useEffect(() => {
    const q = search?.trim()?.toLowerCase() ?? "";
    if (!q) {
      setFiltered(Array.isArray(contacts) ? contacts : []);
    } else {
      setFiltered(
        (Array.isArray(contacts) ? contacts : []).filter(
          (c) =>
            c?.email?.toLowerCase()?.includes(q) ||
            c?.name?.toLowerCase()?.includes(q) ||
            c?.phoneNumber?.includes(q)
        )
      );
      setPage(1);
    }
  }, [search, contacts]);

  const totalPages = Math.ceil((Array.isArray(filtered) ? filtered.length : 0) / perPage);
  const paginated = (Array.isArray(filtered) ? filtered : []).slice((page - 1) * perPage, page * perPage);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8f9fa",
        padding: "32px",
      }}
    >
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "24px", background: "#fff", borderRadius: "14px", boxShadow: "0 3px 20px rgba(0,0,0,0.06)", border: "1px solid #e5e7eb" }}>
        {/* Header */}
        <div style={{ marginBottom: "2rem" }}>
          <h1
            style={{
              fontSize: "2rem",
              fontWeight: "700",
              color: "#1e3a8a",
              margin: "0 0 0.5rem 0",
              letterSpacing: "-0.5px",
              fontFamily: "inherit"
            }}
          >
            Client Mails
          </h1>
          <p
            style={{
              color: "#6b7280",
              margin: 0,
              fontSize: "1rem",
              fontWeight: "500",
              fontFamily: "inherit"
            }}
          >
            {filtered.length} {filtered.length === 1 ? "mail" : "mails"}
          </p>
        </div>

        {/* Search Bar */}
        <div style={{ marginBottom: "1.5rem" }}>
          <input
            type="text"
            style={{
              width: "100%",
              maxWidth: "400px",
              padding: "0.65rem 0.85rem",
              border: "1px solid #d0d5dd",
              borderRadius: "6px",
              fontSize: "16px",
              fontWeight: "500",
              outline: "none",
              boxShadow: "0 2px 8px rgba(37,99,235,0.07)",
              transition: "border-color 0.2s",
              fontFamily: "inherit"
            }}
            placeholder="Search contacts..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onFocus={(e) => (e.target.style.borderColor = "#2563eb")}
            onBlur={(e) => (e.target.style.borderColor = "#d0d5dd")}
          />
        </div>

        {/* Table Container */}
        <div
          style={{
            background: "#ffffff",
            border: "none",
            borderRadius: "8px",
            overflow: "hidden",
            boxShadow: "none"
          }}
        >
          <div style={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "0.95rem",
                fontFamily: "inherit"
              }}
            >
              <thead>
                <tr style={{ background: "#f0f7ff", borderBottom: "1px solid #e5e7eb" }}>
                  <th style={headerStyle}>Name</th>
                  <th style={headerStyle}>Email</th>
                  <th style={headerStyle}>Phone</th>
                  <th style={headerStyle}>Project</th>
                  <th style={headerStyle}>Meeting Date</th>
                  <th style={headerStyle}>Time Zone</th>
                  <th style={headerStyle}>Meeting Time</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan={7} style={{ textAlign: "center", padding: "3rem" }}>
                      <div
                        style={{
                          width: "32px",
                          height: "32px",
                          border: "3px solid #f3f4f6",
                          borderTop: "3px solid #2563eb",
                          borderRadius: "50%",
                          animation: "spin 0.8s linear infinite",
                          margin: "0 auto",
                        }}
                      ></div>
                      <style>
                        {`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}
                      </style>
                    </td>
                  </tr>
                ) : paginated?.length === 0 ? (
                  <tr>
                    <td
                      colSpan={7}
                      style={{
                        textAlign: "center",
                        padding: "3rem",
                        color: "#9ca3af",
                        fontWeight: "500",
                        fontSize: "1rem",
                        fontFamily: "inherit"
                      }}
                    >
                      No contacts found
                    </td>
                  </tr>
                ) : (
                  paginated?.map((c, idx) => (
                    <tr key={c?._id}>
                      <td style={cellStyle}>
                        <span style={{ fontWeight: "600", color: "#1e3a8a", fontFamily: "inherit" }}>
                          {c?.name ?? "—"}
                        </span>
                      </td>
                      <td style={cellStyle}>
                        <span style={{ color: "#2563eb", fontWeight: "500", fontFamily: "inherit" }}>
                          {c?.email ?? "—"}
                        </span>
                      </td>
                      <td style={cellStyle}>
                        <span style={{ color: "#475569", fontWeight: "500", fontFamily: "inherit" }}>
                          {c?.phoneNumber ?? "—"}
                        </span>
                      </td>
                      <td style={cellStyle}>
                        <span
                          style={{
                            display: "inline-block",
                            maxWidth: "200px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            color: "#475569",
                            fontWeight: "500",
                            fontFamily: "inherit"
                          }}
                          title={c?.projectDesc}
                        >
                          {c?.projectDesc ?? "—"}
                        </span>
                      </td>
                      <td style={cellStyle}>
                        <span style={{ color: "#475569", fontWeight: "500", fontFamily: "inherit" }}>
                          {(() => {
                            if (!c?.meetingDate) return "—";
                            const d = new Date(c.meetingDate);
                            return d instanceof Date && !isNaN(d)
                              ? d.toLocaleDateString("en-US", {
                                  year: "numeric",
                                  month: "short",
                                  day: "numeric",
                                })
                              : "—";
                          })()}
                        </span>
                      </td>
                      <td style={cellStyle}>
                        <span style={{ color: "#475569", fontWeight: "500", fontFamily: "inherit" }}>
                          {c?.meetingTimeZone ?? "—"}
                        </span>
                      </td>
                      <td style={cellStyle}>
                        <span style={{ color: "#475569", fontWeight: "500", fontFamily: "inherit" }}>
                          {c?.meetingTime ?? "—"}
                        </span>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "1.25rem 0.5rem",
              borderTop: "1px solid #f3f4f6",
              marginTop: "8px"
            }}
          >
            <div style={{ color: "#6b7280", fontSize: "0.95rem", fontWeight: "500", fontFamily: "inherit" }}>
              Page {page} of {totalPages || 1}
            </div>
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <button
                onClick={() => setPage(page - 1)}
                disabled={page === 1}
                style={{
                  ...buttonStyle,
                  opacity: page === 1 ? 0.4 : 1,
                  cursor: page === 1 ? "not-allowed" : "pointer",
                  fontFamily: "inherit"
                }}
              >
                Previous
              </button>
              <button
                onClick={() => setPage(page + 1)}
                disabled={page === (totalPages || 1)}
                style={{
                  ...buttonStyle,
                  opacity: page === (totalPages || 1) ? 0.4 : 1,
                  cursor: page === (totalPages || 1) ? "not-allowed" : "pointer",
                  fontFamily: "inherit"
                }}
              >
                Next
              </button>
            </div>
          </div>
          {/* end pagination */}
        </div>
      </div>
    </div>
  );
};

const headerStyle = {
  padding: "0.875rem 1rem",
  textAlign: "left",
  color: "#222",
  fontWeight: "600",
  fontSize: "0.95rem",
  textTransform: "uppercase",
  letterSpacing: "0.025em",
  fontFamily: "inherit"
};

const cellStyle = {
  padding: "1rem",
  fontSize: "1rem",
  verticalAlign: "middle",
  color: "#222",
  fontWeight: "500",
  fontFamily: "inherit"
};

const buttonStyle = {
  padding: "0.5rem 1.1rem",
  border: "1px solid #d0d5dd",
  borderRadius: "6px",
  background: "#e8efff",
  color: "#1e3a8a",
  fontSize: "1rem",
  fontWeight: "600",
  cursor: "pointer",
  transition: "all 0.15s",
  fontFamily: "inherit"
};

export default ContactList;